// Import necessary libraries and components
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  setCategories,
  setSelectedCategory,
  setVideos,
} from "../slices/categorySlice";
import Navbar from "../Pages/Navbar";
import VideoCards from "../Pages/VideoCards";
import Footer from "../Pages/Footer";
import Header from "../Pages/Header";
import PopUp from "../Pages/PopUp";
import Login from "../Pages/Login";
import ContinueWatching from "../Pages/ContinueWatching";
import {base_url_toonflix, HomeApi} from "../Api/api"
import {toast } from 'react-toastify';
import Cookies from "js-cookie";
import 'react-toastify/dist/ReactToastify.css';
import {useNavigate} from 'react-router-dom'

const Home = () => {
  const dispatch = useDispatch();

  const storeCategory = useSelector((state) => state.category);
  const navigate = useNavigate()

   const urlParams = new URLSearchParams(window.location.search);
  // const number = urlParams.get('msisdn');

  // const number = Cookies.get('number')
  // const ExtId = Cookies.get('extId')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(HomeApi);
        console.log("resData",response.data);
        const { categories, videos } = response.data;

        console.log(categories,'cats')
        console.log(videos,'videos')

        dispatch(setCategories(categories));
        dispatch(setVideos(videos));
        dispatch(setSelectedCategory("All"));
     
      } catch (error) {
        console.error("Error fetching data:", error);
   
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <>
      <div className="text-sm  ">

        <Navbar />
        <>

          <Header categories={storeCategory} />
          <ContinueWatching/>
          <VideoCards categories={storeCategory} />
        </>

        </div>          
      <Footer className="" /> 
    </>
  );
};

export default Home;

